export function usePublicHead(
  { title, description, context },
  additionalMeta = []
) {
  return {
    title,
    meta: [
      {
        hid: "og:title",
        property: "og:title",
        content: title,
      },
      {
        hid: "description",
        name: "description",
        content: description,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: description,
      },
      {
        hid: "og:image",
        property: "og:image",
        content: "/joszaki-head.png",
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `${context.$helpers.topDomain}${context.$route.fullPath}`,
      },
      ...additionalMeta,
    ],
  };
}
